/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC4610Storage,
  HERC4610StorageInterface,
} from "../../../../contracts/dependant/erc4610/HERC4610Storage";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
] as const;

const _bytecode =
  "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";

type HERC4610StorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC4610StorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC4610Storage__factory extends ContractFactory {
  constructor(...args: HERC4610StorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    baseURI_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC4610Storage> {
    return super.deploy(
      name_,
      symbol_,
      baseURI_,
      overrides || {}
    ) as Promise<HERC4610Storage>;
  }
  override getDeployTransaction(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    baseURI_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      baseURI_,
      overrides || {}
    );
  }
  override attach(address: string): HERC4610Storage {
    return super.attach(address) as HERC4610Storage;
  }
  override connect(signer: Signer): HERC4610Storage__factory {
    return super.connect(signer) as HERC4610Storage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC4610StorageInterface {
    return new utils.Interface(_abi) as HERC4610StorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC4610Storage {
    return new Contract(address, _abi, signerOrProvider) as HERC4610Storage;
  }
}
